import React from "react";
import { Box, Text, HStack, VStack, Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const PumpDevice = ({ pumps }) => {
    const { t } = useTranslation();

    const machineStatus_Direct = [
        { id: 1, label: "DIRECT FEED", bitPosition: 0, positiveIsGood: false },
    ];

    const machineStatusLabels_9Relay = [
        { id: 1, label: "控制電源", bitPosition: 8, positiveIsGood: true },
        { id: 2, label: "一號泵運行", bitPosition: 1, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 0, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 3, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 2, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 7, positiveIsGood: false },
        { id: 7, label: "天台水缸高水位", bitPosition: 6, positiveIsGood: false },
        { id: 8, label: "地下水缸低水位", bitPosition: 5, positiveIsGood: false },
        { id: 9, label: "地下水缸高水位", bitPosition: 4, positiveIsGood: false },    // Estatimate 28Aug2025
    ];

    const machineStatusLabels_6Relay = [
        { id: 1, label: "控制電源", bitPosition: 5, positiveIsGood: true },
        { id: 2, label: "一號泵運行", bitPosition: 1, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 0, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 3, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 2, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 4, positiveIsGood: false },   // Estatimate 28Aug2025
    ];

    const machineStatusLabels_5Relay = [
        { id: 1, label: "一號泵運行", bitPosition: 3, positiveIsGood: true },
        { id: 2, label: "一號泵故障", bitPosition: 4, positiveIsGood: false },
        { id: 3, label: "二號泵運行", bitPosition: 1, positiveIsGood: true },
        { id: 4, label: "二號泵故障", bitPosition: 2, positiveIsGood: false },
        { id: 5, label: "天台水缸低水位", bitPosition: 0, positiveIsGood: false },   // Estatimate 28Aug2025
    ];

    const getStatusLabels = (battery) => {
        let pump = Math.floor(battery / 10);
        if (pump === 9) return machineStatus_Direct;
        if (pump === 3) return machineStatusLabels_9Relay;
        if (pump === 2) return machineStatusLabels_6Relay;
        if (pump === 1) return machineStatusLabels_5Relay;
        if (pump === 7) return null; // Under Construction case
        return machineStatusLabels_9Relay; // default
    };

    const currentStatusLabels = pumps?.length > 0 ? getStatusLabels(pumps[0].battery) : [];
    const isDirectFeed = pumps?.length > 0 && Math.floor(pumps[0].battery / 10) === 9;
    const isUnderConstruction = pumps?.length > 0 && Math.floor(pumps[0].battery / 10) === 7;

    return (
        <Box borderWidth="1px" borderRadius="lg" p={4} boxShadow="md" width="100%">
            <Text fontSize="2xl" fontWeight="bold" mb={3}>
                {pumps[0]?.modelName || '未知型號'}淡水泵控制箱狀態
            </Text>

            <VStack spacing={2} align="stretch">
                {pumps?.length > 0 ? (
                    isUnderConstruction ? (
                        <Text
                            fontSize="48px"
                            fontWeight="bold"
                            color="orange.500"
                            textAlign="center"
                            py={8}
                        >
                            Under Construction
                        </Text>
                    ) : isDirectFeed ? (
                        <Text
                            fontSize="48px"
                            fontWeight="bold"
                            color="green.300"
                            textAlign="center"
                            py={8}
                        >
                            DIRECT FEED
                        </Text>
                    ) : (
                        currentStatusLabels.map((item, index) => {
                            const bitValue = pumps[0].status?.charAt(item.bitPosition) || '0';
                            const circleColor = bitValue === '1'
                                ? (item.positiveIsGood ? 'green.500' : 'red.500')
                                : index === 0 ? (currentStatusLabels.length < 8 ? 'gray.500' : 'red.500') : 'gray.500';
                            const statusText = bitValue === '1'
                                ? (item.positiveIsGood ? "運行中" : "異常")
                                : (item.positiveIsGood ? "停止" : "正常");

                            return (
                                <HStack key={item.id} spacing={3} alignItems="center">
                                    <Box w="20px" h="20px" borderRadius="full" bg={circleColor} boxShadow={`0 0 5px ${circleColor}`} flexShrink={0} />
                                    <Text flex={1} fontSize="md">{item.label}</Text>
                                    <Badge
                                        colorScheme={circleColor.replace('.500', '')}
                                        fontSize="sm"
                                        px={2}
                                        py={1}
                                    >
                                        {statusText}
                                    </Badge>
                                </HStack>
                            );
                        })
                    )
                ) : (
                    <Text fontSize="sm">{t("no_pump_data")}</Text>
                )}
            </VStack>
        </Box>
    );
};